const COLORS = {
  black: {
    base: '#12151A',
    light: '#1B1F26',
    lighter: '#292E36',
    lightest: '#383E47'
  },
  grey: {
    base: '#555C67',
    light: '#788290',
    lighter: '#9EA9B8',
    lightest: '#C8CFD9'
  },
  silver: {
    base: '#E0E6EE',
    light: '#F1F5FB',
    lighter: '#FAFBFD',
    lightest: '#FFFFFF'
  },
  blue: {
    lightest: '#E6ECFB',
    lighter: '#AABEF1',
    light: '#7797E8',
    base: '#4C76E0',
    dark: '#2859D4',
    darker: '#1F48B0',
    darkest: '#1A3C92'
  },
  green: {
    lightest: '#D4FAE8',
    lighter: '#94DFBC',
    light: '#6BD2A2',
    base: '#48C78C',
    dark: '#35AB74',
    darker: '#2C8F61',
    darkest: '#257751'
  },
  red: {
    lightest: '#FAE4E5',
    lighter: '#EEAAAF',
    light: '#E47980',
    base: '#DB4F58',
    dark: '#C73841',
    darker: '#AA232C',
    darkest: '#8D1D25'
  },
  gold: {
    lightest: '#FFF7E3',
    lighter: '#FFE6A9',
    light: '#FFD56B',
    base: '#FFC636',
    dark: '#FCB605',
    darker: '#D49800',
    darkest: '#B07E00'
  },
  mint: {
    lightest: '#D2FAF1',
    lighter: '#92E3D1',
    light: '#67D8BF',
    base: '#42CFB0',
    dark: '#2EB597',
    darker: '#26967D',
    darkest: '#207D68'
  },
  orange: {
    lightest: '#FFF5ED',
    lighter: '#F5D5B5',
    light: '#EEB67E',
    base: '#E89B4F',
    dark: '#E2882F',
    darker: '#BD6A19',
    darkest: '#9D5815'
  },
  teal: {
    lightest: '#D7FAFA',
    lighter: '#98E3E3',
    light: '#6BD3D3',
    base: '#47C9C9',
    dark: '#34B3B3',
    darker: '#2A9191',
    darkest: '#237878'
  },
  indigo: {
    lightest: '#EFEFFC',
    lighter: '#B5B5F1',
    light: '#8181E8',
    base: '#5555E0',
    dark: '#3838D8',
    darker: '#2121B4',
    darkest: '#1B1B95'
  },
  purple: {
    lightest: '#F6F1FE',
    lighter: '#D3B4F5',
    light: '#B47EED',
    base: '#9950E6',
    dark: '#7E22DF',
    darker: '#691BBA',
    darkest: '#57169A'
  },
  pink: {
    lightest: '#FCEFF5',
    lighter: '#F1B3CF',
    light: '#E87FAF',
    base: '#E05E99',
    dark: '#D83880',
    darker: '#B82166',
    darkest: '#951B52'
  }
};

const [lightest, lighter, light, base, dark, darker, darkest] = [
  'lightest',
  'lighter',
  'light',
  'base',
  'dark',
  'darker',
  'darkest'
];

export const colorSteps = [lightest, lighter, light, base, dark, darker, darkest];
export const colorStepsReverse = [darkest, darker, dark, base, light, lighter, lightest];

export default COLORS;
